import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/matikka';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-298" data-mp="pujaxj4imb7s">
      <div className="mx-auto max-w-6xl" data-id="element-299" data-mp="b5wn0t0tob4y">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-300" data-mp="b4vcqqrmrsoa">
          Mitä <em className="text-red-700" style={{
          hyphens: 'manual'
        }} data-id="element-301" data-mp="2604781466ht">MATIKKA VALMIS™</em> sisältää?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-302" data-mp="74bcvffoaayg">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-303" data-mp="72gplugxi6r7">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-304" data-mp="3tazycvhdtjdt">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Osat" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-305" data-mp="3cscqf91biy5o">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-306" data-mp="3lshxtj6ihwju" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-307" data-mp="2af74qxc7c3p0">{item.number}</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-308" data-mp="26dtved9whidc">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-309" data-mp="26c0yhpp3acij">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-310" data-mp="j30wcp1gszlx">
          <AnimatePresence mode="wait" initial={false} data-id="element-311" data-mp="o12ftb2sz0xx">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-312" data-mp="3mjr71h7zs0ty">
              <div className="lg:col-span-5" data-id="element-313" data-mp="5cxhij4x086i">
                <p className="text-sm font-semibold text-red-700" data-id="element-314" data-mp="1bs7sjhdg5d40">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-315" data-mp="1gp7zdui4ejw6">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-316" data-mp="3180qvi3jyem5">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-317" data-mp="2wail20ku0fid">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-318" data-mp="2rgxlw57i5fhl">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-319" data-mp="2mkpbf5492agr">Sisältö</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-320" data-mp="2hkkx9lqtdrtp">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-321" data-mp="2dipusdx5d8ec">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-322" data-mp="28jmpcsd9905u" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-323" data-mp="6tb8r9hbdb9g">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-324" data-mp="1uq5102us9g9">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-325" data-mp="2znjk2g5v4csu">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-326" data-mp="2zkxakazevn7z">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-327" data-mp="2lmz3zrrc0v31">
              Mikä tekee MATIKKA VALMIS™ -paketista erilaisen?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-328" data-mp="2bwvzauaulsov">
              Koko lukuvuoden matematiikka – järjestettynä ja käyttövalmiina.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-329" data-mp="22y28jkk77wj8">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-330" data-mp="1sz38urhevb8d">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-331" data-mp="1t04hkpayflmx" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-332" data-mp="1xwl79nxsy824">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-333" data-mp="1ecmmmin725dp">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}